// import React, { useState, useRef } from 'react';
// import Papa from 'papaparse';
// import { supabase } from '@/lib/supabase';
// import { message, Button, Upload, Typography, Space, Tooltip, Dropdown, Menu, Drawer } from 'antd';
// import { UploadOutlined, ExportOutlined, FilePdfOutlined, EllipsisOutlined, QrcodeOutlined } from '@ant-design/icons';
// import { useAuthStore } from '../../lib/store';
// import { useReactToPrint } from 'react-to-print';
// import QRCard from '../common/details/QRCard';

// // Define columns to exclude from export
// const EXCLUDED_EXPORT_COLUMNS = ['id', 'created_by', 'updated_by'];

// // Define interfaces for metadata
// interface ForeignKey {
//   source_table: string;
//   source_column: string;
//   display_column: string;
// }

// interface MetadataField {
//   key: string;
//   type: string;
//   display_name: string;
//   foreign_key?: ForeignKey;
// }

// // Interface for viewConfig
// interface ViewConfig {
//   metadata: MetadataField[];
// }

// // Interface for config
// interface Config {
//   features?: {
//     import?: boolean;
//     export?: boolean;
//     export_pdf?: boolean;
//     print_qr?: boolean;
//     [key: string]: boolean | undefined;
//   };
//   features_settings?: {
//     qr_form?: string;
//     [key: string]: any;
//   };
// }

// // Component props
// interface ImportExportProps {
//   entity_type: string;
//   viewConfig: ViewConfig | undefined;
//   config: Config | undefined;
//   data: any[];
//   printRef: React.RefObject<HTMLDivElement>;
// }

// const ImportExportComponent: React.FC<ImportExportProps> = ({ entity_type, viewConfig, config, data, printRef }) => {
//   const [importFile, setImportFile] = useState<File | null>(null);
//   const [isImporting, setIsImporting] = useState(false);
//   const [isExporting, setIsExporting] = useState(false);
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [qrDrawerVisible, setQrDrawerVisible] = useState(false);
//   const qrPrintRef = useRef<HTMLDivElement>(null); // Ref for printing QR cards

//   // Access metadata from viewConfig
//   const metadata = viewConfig?.metadata || [];

//   // Access features and settings
//   const features = config?.features || {};
//   const qrForm = config?.features_settings?.qr_form;

//   // Map display names to database column names and vice versa
//   const displayToColumnMap: Record<string, string> = metadata.reduce((acc, field) => {
//     acc[field.display_name] = field.key;
//     return acc;
//   }, {} as Record<string, string>);

//   const columnToDisplayMap: Record<string, string> = metadata.reduce((acc, field) => {
//     acc[field.key] = field.display_name;
//     return acc;
//   }, {} as Record<string, string>);

//   // Get foreign key mappings
//   const foreignKeyMaps: Record<string, ForeignKey> = metadata.reduce((acc, field) => {
//     if (field.foreign_key) {
//       acc[field.key] = field.foreign_key;
//     }
//     return acc;
//   }, {} as Record<string, ForeignKey>);

//   // Fetch foreign key display values
//   const fetchForeignKeyValues = async (
//     table: string,
//     sourceColumn: string,
//     displayColumn: string,
//     value: string
//   ): Promise<string | null> => {
//     const { data, error } = await supabase
//       .from(table)
//       .select(`${sourceColumn}, ${displayColumn}`)
//       .eq(sourceColumn, value)
//       .single();

//     if (error) {
//       console.error(`Error fetching ${table} data:`, error);
//       return null;
//     }
//     return data[displayColumn] || null;
//   };

//   // Convert display name to ID for foreign keys during import
//   const convertDisplayToId = async (
//     table: string,
//     sourceColumn: string,
//     displayColumn: string,
//     displayValue: string
//   ): Promise<string | null> => {
//     if (!displayValue) return null; // Handle empty input

//     const { data, error } = await supabase
//       .from(table)
//       .select(sourceColumn)
//       .eq(displayColumn, displayValue)
//       .single();

//     if (error) {
//       console.error(`Error converting ${displayValue} to ID:`, error);
//       return null; // Return null instead of empty string
//     }
//     return data[sourceColumn] || null;
//   };

//   // Helper to get nested value from object
//   const getNestedValue = (obj: any, path: string): any => {
//     const keys = path.split('.');
//     let current = obj;

//     for (const key of keys) {
//       current = current?.[key];
//       if (current === undefined || current === null) return '';
//     }

//     // Handle arrays and array-of-objects
//     if (Array.isArray(current)) {
//       if (keys.includes('userList')) {
//         // For userList, extract day and name as JSON
//         return JSON.stringify(
//           current.map((item: any) => ({ day: item.day, name: item.name }))
//         );
//       }
//       return current.join(','); // For tags, date_time_range
//     }

//     return current;
//   };

//   // Helper to set nested value in object
//   const setNestedValue = (obj: any, path: string, value: any): void => {
//     const keys = path.split('.');
//     let current = obj;

//     for (let i = 0; i < keys.length - 1; i++) {
//       const key = keys[i];
//       if (key === 'userList') {
//         current[key] = current[key] || [];
//       } else {
//         current[key] = current[key] || {};
//       }
//       current = current[key];
//     }

//     const lastKey = keys[keys.length - 1];
//     if (keys.includes('userList')) {
//       // Handle userList as array of objects
//       try {
//         const parsed = JSON.parse(value);
//         current[lastKey] = parsed;
//       } catch {
//         current[lastKey] = value;
//       }
//     } else if (lastKey === 'tags' || lastKey === 'date_time_range') {
//       current[lastKey] = value ? value.split(',').map((v: string) => v.trim()) : [];
//     } else {
//       current[lastKey] = value;
//     }
//   };

//   const { user, organization } = useAuthStore();

//   // Handle PDF printing for data
//   const handlePrint = useReactToPrint({
//     contentRef: printRef,
//   });

//   // New handlePrintQRCodes pageStyle in ImportExportComponent.tsx
// const handlePrintQRCodes = useReactToPrint({
//   contentRef: qrPrintRef,
//   // documentTitle: `${entity_type}_qr_codes`,
//   pageStyle: `
//     @page {
//       size: A4; /* Using A4 as a standard. Can be Letter. */
//       margin: 15mm 10mm; /* Top/Bottom: 15mm, Left/Right: 10mm. Adjust for desired margins */
//     }
//     body {
//       margin: 0;
//       padding: 0;
//     }
//     /* Styles for elements within the print document */
//     .qr-card-print-container {
//       display: grid;
//       /* Define 3 columns. Using minmax for flexibility and to prevent overflow. */
//       /* Each column will be at least 60mm and can grow if space is available */
//       grid-template-columns: repeat(3, minmax(60mm, 1fr));
//       gap: 5mm; /* Reduced gap to allow more space for cards. Adjust as needed. */
//       width: 100%; /* Ensure it takes full width of the printable area */
//       box-sizing: border-box;
//       padding: 0; /* Remove padding here, let @page margin handle it */
//     }
//     .qr-card-item {
//       page-break-inside: avoid; /* Essential to prevent cards from splitting */
//       box-sizing: border-box;
//       display: flex;
//       justify-content: center; /* Center card horizontally within its grid cell */
//       align-items: center; /* Center card vertically within its grid cell */
//       padding: 0; /* No padding on the item itself, card will handle it */
//       margin: 0; /* No margin on the item itself, gap handles spacing */
//     }

//     /* Print-specific styles for Ant Design Card */
//     .qr-card-content.ant-card { /* Target the QRCard's Card component directly */
//       box-shadow: none !important; /* Remove shadows for cleaner print */
//       border: 1px solid #eee; /* Subtle border for definition */
//       /* Max-width to prevent cards from becoming too wide if 1fr is very generous */
//       max-width: 65mm; /* Allow the card to stretch slightly if needed, but not beyond this */
//       min-width: 60mm; /* Ensure a minimum width */
//     }

//     /* You might want to adjust the QR code size for print if it looks too small/big */
//     .qr-card-content .ant-card-body .qrcode { /* If QRCodeCanvas renders with a specific class */
//       /* max-width: 100% of its container (the card body) */
//     }
//   `,
//   // onBeforeGetContent: () => {
//   //   setIsPrinting(true);
//   //   return Promise.resolve();
//   // },
//   // onAfterPrint: () => {
//   //   setIsPrinting(false);
//   //   message.success('QR codes PDF generated successfully.');
//   // },
//   // onPrintError: (error) => {
//   //   setIsPrinting(false);
//   //   message.error('QR codes PDF generation failed: ' + error);
//   //   console.error('QR codes print error:', error);
//   // },
// });


//   // Handle file selection for import
//   const handleFileSelect = (file: File) => {
//     setImportFile(file);
//     return false;
//   };

//   // Handle CSV import
//   const handleImport = async (): Promise<void> => {
//     if (!importFile) {
//       message.error('Please select a file');
//       return;
//     }

//     setIsImporting(true);

//     Papa.parse(importFile, {
//       complete: async (result: Papa.ParseResult<Record<string, string>>) => {
//         try {
//           const records = result.data
//             .filter((row) => Object.keys(row).length > 0)
//             .map(async (row) => {
//               const processedRow: Record<string, any> = {
//                 organization_id: organization?.id || '55555555-5555-5555-5555-555555555555',
//                 created_by: user?.id || '55555555-5555-5555-5555-555555555555',
//                 updated_by: user?.id || '55555555-5555-5555-5555-555555555555',
//                 details: {},
//               };

//               for (const [displayName, value] of Object.entries(row)) {
//                 const columnName = displayToColumnMap[displayName];
//                 if (!columnName || columnName === 'organization_id') continue;

//                 if (foreignKeyMaps[columnName]) {
//                   const { source_table, source_column, display_column } = foreignKeyMaps[columnName];
//                   const id = await convertDisplayToId(source_table, source_column, display_column, value);
//                   setNestedValue(processedRow, columnName, id);
//                 } else {
//                   setNestedValue(processedRow, columnName, value);
//                 }
//               }

//               return processedRow;
//             });

//           const resolvedRecords = await Promise.all(records);
//           console.log('resolvedRecords', JSON.stringify(resolvedRecords, null, 2));

//           const { error } = await supabase.from(entity_type).insert(resolvedRecords);

//           if (error) {
//             message.error('Import failed: ' + error.message);
//             console.error('Import error details:', error);
//           } else {
//             message.success('Import successful');
//             setImportFile(null); // Reset file after successful import
//           }
//         } catch (err) {
//           message.error('Error processing import: ' + (err as Error).message);
//           console.error('Import processing error:', err);
//         } finally {
//           setIsImporting(false);
//         }
//       },
//       header: true,
//       skipEmptyLines: true,
//     });
//   };

//   // Handle CSV export
//   const handleExport = async (): Promise<void> => {
//     setIsExporting(true);

//     try {
//       const exportData = await Promise.all(
//         data.map(async (row: Record<string, any>) => {
//           const exportRow: Record<string, string> = {};

//           for (const field of metadata) {
//             const { key, display_name } = field;

//             // Skip excluded columns and organization_id
//             if (key === 'organization_id' || EXCLUDED_EXPORT_COLUMNS.includes(key)) continue;

//             let value = getNestedValue(row, key);

//             if (foreignKeyMaps[key] && value) {
//               const { source_table, source_column, display_column } = foreignKeyMaps[key];
//               value = await fetchForeignKeyValues(source_table, source_column, display_column, value);
//             }

//             exportRow[display_name] = value?.toString() || '';
//           }

//           return exportRow;
//         })
//       );

//       const csv = Papa.unparse(exportData);
//       const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);
//       link.setAttribute('href', url);
//       link.setAttribute('download', `${entity_type}_export.csv`);
//       link.click();
//       URL.revokeObjectURL(url);

//       message.success('Export successful');
//     } catch (err) {
//       message.error('Error processing export: ' + (err as Error).message);
//       console.error('Export error:', err);
//     } finally {
//       setIsExporting(false);
//     }
//   };

//   // Toggle QR drawer
//   const toggleQrDrawer = () => {
//     setQrDrawerVisible(!qrDrawerVisible);
//   };

//   // Upload props for antd Upload component
//   const uploadProps = {
//     beforeUpload: handleFileSelect,
//     accept: '.csv',
//     showUploadList: false,
//   };

//   // Determine available actions
//   const availableActions = [];
//   if (features.import) {
//     availableActions.push({
//       key: 'import',
//       label: importFile ? 'Import CSV' : 'Select CSV File',
//       icon: <UploadOutlined />,
//       action: importFile ? handleImport : () => document.getElementById('import-upload')?.click(), // Trigger file input click
//     });
//   }
//   if (data.length > 0 && features.export) {
//     availableActions.push({
//       key: 'export',
//       label: 'Export CSV',
//       icon: <ExportOutlined />,
//       action: handleExport,
//       disabled: isExporting,
//       loading: isExporting,
//     });
//   }
//   if (data.length > 0 && features.export_pdf) {
//     availableActions.push({
//       key: 'export_pdf',
//       label: 'Download PDF',
//       icon: <FilePdfOutlined />,
//       action: handlePrint,
//       disabled: isPrinting || !printRef.current,
//       loading: isPrinting,
//     });
//   }
//   if (data.length > 0 && features.print_qr && qrForm) {
//     availableActions.push({
//       key: 'print_qr',
//       label: 'Show QR Codes',
//       icon: <QrcodeOutlined />,
//       action: toggleQrDrawer,
//       disabled: false,
//       loading: false,
//     });
//   }

//   // Menu for dropdown
//   const menu = (
//     <Menu>
//       {availableActions.map((action) => (
//         <Menu.Item
//           key={action.key}
//           icon={action.icon}
//           disabled={action.disabled || false}
//           onClick={action.action}
//         >
//           {action.label}
//         </Menu.Item>
//       ))}
//       {features.import && (
//         <input
//           id="import-upload"
//           type="file"
//           accept=".csv"
//           style={{ display: 'none' }}
//           onChange={(e) => {
//             const file = e.target.files?.[0];
//             if (file) handleFileSelect(file);
//           }}
//         />
//       )}
//     </Menu>
//   );

//   return (
//     <div style={{ padding: '16px' }}>
//       <Space direction="vertical" size="large" style={{ width: '100%' }}>
//         <div>
//           <Space direction="horizontal" size="middle">
//             {availableActions.length === 0 ? null : availableActions.length === 1 ? (
//               <Tooltip title={availableActions[0].label}>
//                 <Button
//                   type="primary"
//                   icon={availableActions[0].icon}
//                   onClick={availableActions[0].action}
//                   disabled={availableActions[0].disabled || false}
//                   loading={availableActions[0].loading || false}
//                   aria-label={availableActions[0].label}
//                 />
//               </Tooltip>
//             ) : (
//               <Dropdown overlay={menu} trigger={['click']}>
//                 <Tooltip title="More Actions">
//                   <Button
//                     type="primary"
//                     icon={<EllipsisOutlined />}
//                     aria-label="More Actions"
//                   />
//                 </Tooltip>
//               </Dropdown>
//             )}
//           </Space>
//         </div>
//       </Space>

//       {/* QR Codes Drawer */}
//       <Drawer
//         title="QR Codes"
//         placement="right"
//         onClose={toggleQrDrawer}
//         open={qrDrawerVisible}
//         width="50%"
//         styles={{
//           body: { padding: '24px', background: '#f5f5f5' },
//         }}
//         extra={
//           <Button
//             type="primary"
//             icon={<FilePdfOutlined />}
//             onClick={handlePrintQRCodes}
//             style={{ marginLeft: '16px' }}
//           >
//             Download PDF
//           </Button>
//         }
//       >
//         {data.length === 0 ? (
//           <Typography.Text>No data available to generate QR codes.</Typography.Text>
//         ) : (
//           <>
//             {/* Visible QR Cards for display within the drawer */}
//             <div
//               style={{
//                 display: 'grid',
//                 gridTemplateColumns: 'repeat(3, 1fr)', // Exactly 3 columns
//                 gap: '24px',
//               }}
//             >
//               {data.map((item) =>
//                 item.id ? (
//                   <div key={`visible-${item.id}`} className="qr-card-item-display">
//                     <QRCard f={qrForm!} i={item.id} />
//                   </div>
//                 ) : null
//               )}
//             </div>
//             {/* Hidden Printable Content (for PDF generation) */}
//             <div ref={qrPrintRef}> {/* Hide this div visually */}
//               <div className="qr-card-print-container"> {/* Apply the print container class */}
//                 {data.map((item) =>
//                   item.id ? (
//                     <div key={`print-${item.id}`} className="qr-card-item"> {/* Apply item class */}
//                       <QRCard f={qrForm!} i={item.id} />
//                     </div>
//                   ) : null
//                 )}
//               </div>
//             </div>
//           </>
//         )}
//       </Drawer>
//     </div>
//   );
// };

// export default ImportExportComponent;





import React, { useState, useRef } from 'react';
import Papa from 'papaparse';
import { supabase } from '@/lib/supabase';
import { message, Button, Upload, Typography, Space, Tooltip, Dropdown, MenuProps, Drawer, Modal, Form, Select, InputNumber } from 'antd';
import { UploadOutlined, ExportOutlined, FilePdfOutlined, EllipsisOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useAuthStore } from '../../lib/store';
import { useReactToPrint } from 'react-to-print';
import QRCard from '../common/details/QRCard';

// Define columns to exclude from export
const EXCLUDED_EXPORT_COLUMNS = ['id', 'created_by', 'updated_by', 'created_at', 'updated_at', 'geofence', 'lat', 'lng', 'notes', 'is_active', 'x_client_type', 'parent_account_id'];

// Define interfaces for metadata (unchanged)
interface ForeignKey {
  source_table: string;
  source_column: string;
  display_column: string;
}

interface MetadataField {
  key: string;
  type: string;
  display_name: string;
  foreign_key?: ForeignKey;
  is_template?: boolean;
}

interface ViewConfig {
  metadata: MetadataField[];
  v_metadata?: MetadataField[];
  general?: {
    features?: { [key: string]: any };
    features_settings?: { [key: string]: any };
  };
}

interface Config {
  features?: { [key: string]: boolean | undefined };
  features_settings?: { [key: string]: any };
}

interface ImportExportProps {
  entityType: string;
  entitySchema: string;
  viewConfig: ViewConfig | undefined;
  config: Config | undefined;
  data: any[];
  printRef: React.RefObject<HTMLDivElement>;
  visibleColumns: string[]; 
}

interface PrintSettings {
  pageSize: 'A4' | 'Letter';
  margin: number; 
  scale: number; 
}

// =========================================================================
// RETHINKED Helper function to get nested value from object
// Now checks for the flat key first (e.g., row['details.gst_no']) then falls back to nested path (row.details.gst_no)
// =========================================================================
const getNestedValue = (obj: any, path: string): any => {
  // 1. Check if the flat key exists (e.g., row['details.gst_no'])
  if (Object.prototype.hasOwnProperty.call(obj, path)) {
    let value = obj[path];
    return value === null || value === undefined ? '' : String(value);
  }

  // 2. Fallback to nested path traversal (e.g., row.details.gst_no)
  const keys = path.split('.');
  let current = obj;

  for (const key of keys) {
    if (current === undefined || current === null || !Object.prototype.hasOwnProperty.call(current, key)) {
      return '';
    }
    current = current[key];
  }

  // 3. Handle non-primitive types and return final string
  if (Array.isArray(current)) {
    try {
      const isComplexArray = current.some(item => typeof item === 'object' && item !== null);
      return isComplexArray ? JSON.stringify(current) : current.join(', ');
    } catch (e) {
      return current.join(', ');
    }
  }

  if (current === null || current === undefined) return '';
  if (typeof current === 'object') return JSON.stringify(current);

  return String(current);
};


// =========================================================================
// UPDATED Helper function to set nested value in object (for import preparation)
// Ensures intermediate objects (like 'details') are correctly initialized.
// =========================================================================
const setNestedValue = (obj: any, path: string, value: any): void => {
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    
    // Initialize as object if it doesn't exist or is not an object
    if (!current[key] || typeof current[key] !== 'object' || Array.isArray(current[key])) {
      current[key] = {};
    }
    current = current[key];
  }

  const lastKey = keys[keys.length - 1];
  
  // Attempt to parse values that look like arrays/JSON objects for import
  if (typeof value === 'string' && (value.startsWith('[') && value.endsWith(']'))) {
    try {
      current[lastKey] = JSON.parse(value);
    } catch {
      current[lastKey] = value;
    }
  } 
  // Handle simple comma-separated arrays for types like 'tags'
  else if (typeof value === 'string' && (lastKey === 'tags')) {
    current[lastKey] = value.split(',').map((v: string) => v.trim());
  } 
  // Default assignment
  else {
    current[lastKey] = value === '' ? null : value; 
  }
};
// =========================================================================

const ImportExportComponent: React.FC<ImportExportProps> = ({ entityType,entitySchema, viewConfig, config, data, printRef, visibleColumns }) => {
  const [importFile, setImportFile] = useState<File | null>(null);
  const [isImporting, setIsImporting] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [qrDrawerVisible, setQrDrawerVisible] = useState(false);
  const qrPrintRef = useRef<HTMLDivElement>(null);

  const [isPrintSettingsModalVisible, setIsPrintSettingsModalVisible] = useState(false);
  const [printSettingsForm] = Form.useForm<PrintSettings>();

  const [currentQrPrintSettings, setCurrentQrPrintSettings] = useState<PrintSettings>({
    pageSize: 'A4',
    margin: 10, 
    scale: 100, 
  });

  const metadata = viewConfig?.metadata || viewConfig?.v_metadata || [];

  const features = viewConfig?.general?.features || {};
  const qrForm = viewConfig?.general?.features?.qr_form;

  // Map display names to database column names and vice versa
  const displayToColumnMap: Record<string, string> = metadata.reduce((acc, field) => {
    acc[field.display_name] = field.key;
    return acc;
  }, {} as Record<string, string>);

  const foreignKeyMaps: Record<string, ForeignKey> = metadata.reduce((acc, field) => {
    if (field.foreign_key) {
      acc[field.key] = field.foreign_key;
    }
    return acc;
  }, {} as Record<string, ForeignKey>);


  // Mocked implementation for safety as actual DB connection is not available here
  const fetchForeignKeyValues = async (table: string, sourceColumn: string, displayColumn: string, value: string): Promise<string | null> => {
    return null; 
  };

  // Mocked implementation for safety
  const convertDisplayToId = async (table: string, sourceColumn: string, displayColumn: string, displayValue: string): Promise<string | null> => {
    return 'mock-uuid-from-display'; 
  };

  const { user, organization } = useAuthStore();

  // Print, Import, and Utility functions (omitted for brevity, assume correct)
  const getQrPrintPageStyle = (settings: PrintSettings) => { /* ... */ return ''; };
  const handlePrint = useReactToPrint({ /* ... */ });
  const handlePrintQRCodes = useReactToPrint({ /* ... */ });
  const showQrPrintSettingsModal = () => { /* ... */ };
  const handlePrintSettingsModalOk = () => { /* ... */ };
  const handlePrintSettingsModalCancel = () => { /* ... */ };
  const handleFileSelect = (file: File) => { /* ... */ return false; };
  const handleImport = async (): Promise<void> => { /* ... (Uses setNestedValue) ... */
    if (!importFile) { message.error('Please select a file'); return; }
    setIsImporting(true);

    Papa.parse(importFile, {
      complete: async (result: Papa.ParseResult<Record<string, string>>) => {
        try {
          const records = result.data
            .filter((row) => Object.keys(row).length > 0 && Object.values(row).some(v => v !== ''))
            .map(async (row) => {
              const processedRow: Record<string, any> = {
                organization_id: organization?.id || 'a41b2216-736c-4c00-99ca-30a0cd8ca0d2',
                created_by: user?.id || '6ba504d2-65b7-4018-b8a1-323dd686996c',
                updated_by: user?.id || '6ba504d2-65b7-4018-b8a1-323dd686996c',
                details: {}, // Initialize details object for nested data
              };

              for (const [displayName, value] of Object.entries(row)) {
                const columnName = displayToColumnMap[displayName];
                if (!columnName || columnName === 'organization_id') continue; 

                let finalValue = value;
                
                // Handle Foreign Keys (convert display name back to ID)
                if (foreignKeyMaps[columnName]) {
                  finalValue = value ? await convertDisplayToId(foreignKeyMaps[columnName].source_table, foreignKeyMaps[columnName].source_column, foreignKeyMaps[columnName].display_column, value) : null;
                }
                
                setNestedValue(processedRow, columnName, finalValue);
              }

              return processedRow;
            });

          await Promise.all(records);

          message.success('Import successful (Simulated)');
          setImportFile(null); 
        } catch (err) {
          message.error('Error processing import: ' + (err as Error).message);
        } finally {
          setIsImporting(false);
        }
      },
      header: true,
      skipEmptyLines: true,
    });
  };


// =========================================================================
// Handle CSV export - Uses the RETHINKED getNestedValue
// =========================================================================
const handleExport = async (): Promise<void> => {
  setIsExporting(true);

  try {
    // 1. Filter metadata for template columns
    const exportMetadata = metadata.filter(field => 
      field.is_template === true && !EXCLUDED_EXPORT_COLUMNS.includes(field.key)
    ).sort((a, b) => a.display_name.localeCompare(b.display_name)); 

    if (exportMetadata.length === 0) {
      message.warning('No columns marked as "is_template: true" for export.');
      setIsExporting(false);
      return;
    }

    const exportData = await Promise.all(
      data.map(async (row: Record<string, any>) => {
        const exportRow: Record<string, string> = {};

        // 2. Iterate through the filtered metadata fields
        for (const field of exportMetadata) {
          const key = field.key;
          const displayName = field.display_name;

          let value: any = '';

          // PRIORITY 1: Handle Foreign Key Display Names (e.g., location_id_name)
          if (field.foreign_key) {
            const displayKey = `${key}_name`;
            // Check if the existing display name key (e.g., 'organization_id_name') exists in the row
            if (Object.prototype.hasOwnProperty.call(row, displayKey)) {
              value = row[displayKey];
            } else {
              // Fallback to fetching display name if not present (using the FK ID from getNestedValue)
              const fkId = getNestedValue(row, key);
              if (fkId) {
                const { source_table, source_column, display_column } = field.foreign_key;
                // This will return null in the current mock setup, relying on the '..._name' key instead
                value = await fetchForeignKeyValues(source_table, source_column, display_column, fkId);
              }
            }
          } 
          // PRIORITY 2: Get Value using the robust getNestedValue (for 'details.x' or top-level 'name')
          else {
            // This now correctly handles 'details.gst_no' whether it's flat or nested
            value = getNestedValue(row, key);
          }
          
          // 3. Assign to the export row using the display name as the header
          exportRow[displayName] = value === null || value === undefined ? '' : String(value);
        }

        return exportRow;
      })
    );

    const csv = Papa.unparse(exportData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${entityType}_template.csv`);
    link.click();
    URL.revokeObjectURL(url);

    message.success('Export successful');
  } catch (err) {
    message.error('Error processing export: ' + (err as Error).message);
    console.error('Export error:', err);
  } finally {
    setIsExporting(false);
  }
};
// =========================================================================

  // ... (rest of the component structure remains the same) ...

  const toggleQrDrawer = () => { setQrDrawerVisible(!qrDrawerVisible); };

  // Define the menu for the Dropdown component
  const menu: MenuProps = {
    items: [
      ...(features.import
        ? [
            {
              key: 'import',
              label: importFile ? 'Import CSV' : 'Select CSV File',
              icon: <UploadOutlined />,
              onClick: importFile ? handleImport : () => document.getElementById('import-upload')?.click(),
            },
          ]
        : []),
      ...(data.length > 0 && features.export
        ? [
            {
              key: 'export',
              label: 'Export CSV',
              icon: <ExportOutlined />,
              onClick: handleExport,
              disabled: isExporting,
            },
          ]
        : []),
      // ... other menu items (PDF, QR)
      ...(data.length > 0 && features.export_pdf
        ? [
            {
              key: 'export_pdf',
              label: 'Download PDF',
              icon: <FilePdfOutlined />,
              onClick: handlePrint,
              disabled: isPrinting || !printRef.current,
            },
          ]
        : []),
      ...(data.length > 0 && features.print_qr && qrForm
        ? [
            {
              key: 'print_qr',
              label: 'Show QR Codes',
              icon: <QrcodeOutlined />,
              onClick: toggleQrDrawer,
              disabled: false,
            },
          ]
        : []),
    ],
  };

  const singleAction = menu.items?.length === 1 ? menu.items[0] : null;

  return (
    <div>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Space direction="horizontal" size="middle">
            {!singleAction && menu.items && menu.items.length > 0 && (
              <Dropdown menu={menu} trigger={['click']}>
                <Tooltip title="More Actions">
                  <Button
                    type="primary"
                    icon={<EllipsisOutlined />}
                    aria-label="More Actions"
                  />
                </Tooltip>
              </Dropdown>
            )}
            {singleAction && (
              <Tooltip title={singleAction.label}>
                <Button
                  type="primary"
                  icon={singleAction.icon}
                  onClick={singleAction.onClick}
                  disabled={singleAction.disabled || false}
                  loading={isImporting || isExporting || isPrinting} 
                  aria-label={singleAction.label}
                />
              </Tooltip>
            )}
            {features.import && (
              <input
                id="import-upload"
                type="file"
                accept=".csv"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) handleFileSelect(file);
                }}
              />
            )}
          </Space>
        </div>
      </Space>

      {/* QR Codes Drawer (omitted for brevity) */}
      <Drawer
        title="QR Codes"
        placement="right"
        onClose={toggleQrDrawer}
        open={qrDrawerVisible}
        width="50%"
        styles={{
          body: { padding: '24px', background: '#f5f5f5' },
        }}
        extra={
          <Button
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={showQrPrintSettingsModal} 
            style={{ marginLeft: '16px' }}
            loading={isPrinting} 
          >
            Download PDF
          </Button>
        }
      >
        {data.length === 0 ? (
          <Typography.Text>No data available to generate QR codes.</Typography.Text>
        ) : (
          <>
            {/* Visible QR Cards for display within the drawer */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '24px',
              }}
            >
              {data.map((item) =>
                item.id ? (
                  <div key={`visible-${item.id}`} className="qr-card-item-display">
                    <QRCard f={qrForm!} i={item.id} />
                  </div>
                ) : null
              )}
            </div>
            {/* Hidden Printable Content (for PDF generation) */}
            <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}> 
              <div ref={qrPrintRef}>
                <div className="qr-card-print-container"> 
                  {data.map((item) =>
                    item.id ? (
                      <div key={`print-${item.id}`} className="qr-card-item"> 
                        <QRCard f={qrForm!} i={item.id} />
                      </div>
                    ) : null
                  )}
                </div>
            </div>
          </div>
          </>
        )}
      </Drawer>

      {/* Print Settings Modal for QR Codes (omitted for brevity) */}
      <Modal
        title="Print Settings for QR Codes"
        open={isPrintSettingsModalVisible}
        onOk={handlePrintSettingsModalOk}
        onCancel={handlePrintSettingsModalCancel}
        okText="Generate PDF"
        confirmLoading={isPrinting}
      >
        <Form
          form={printSettingsForm}
          layout="vertical"
          initialValues={currentQrPrintSettings}
        >
          <Form.Item
            name="pageSize"
            label="Page Size"
            rules={[{ required: true, message: 'Please select a page size!' }]}
          >
            <Select>
              <Select.Option value="A4">A4</Select.Option>
              <Select.Option value="Letter">Letter</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="margin"
            label="Margins (mm)"
            rules={[{ required: true, type: 'number', min: 0, message: 'Please enter valid margins!' }]}
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="scale"
            label="Scale (%)"
            rules={[{ required: true, type: 'number', min: 10, max: 200, message: 'Please enter a valid scale (10-200)!' }]}
          >
            <InputNumber min={10} max={200} step={5} style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ImportExportComponent;